document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".product-features-section");

  sections.forEach(function (section) {
    const slider = section.querySelector(".product-features-section__grid");
    const prevButton = section.querySelector(".product-features-section__arrow--prev");
    const nextButton = section.querySelector(".product-features-section__arrow--next");
    const status = section.querySelector(".product-features-section__sr-status");

    if (!slider) return;

    const cards = slider.querySelectorAll(".product-features-card");

    if (cards.length <= 3) {
      if (prevButton) {
        prevButton.style.display = "none";
      }

      if (nextButton) {
        nextButton.style.display = "none";
      }

      return;
    }

    if (typeof Flickity === "undefined") {
      console.warn("Flickity is not loaded.");
      return;
    }

    slider.classList.add("is-flickity");

    const flkty = new Flickity(slider, {
      cellSelector: ".product-features-card",
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      draggable: true,
      freeScroll: false,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: false,
      percentPosition: true,
      accessibility: true
    });

    let sliderProgress = 0;

    function updateButtons() {
      if (!flkty) return;

      const isFirst = sliderProgress <= 0.001;
      const isLast = sliderProgress >= 0.999;

      if (prevButton) {
        prevButton.disabled = isFirst;

        prevButton.setAttribute(
          "aria-disabled",
          isFirst ? "true" : "false"
        );
      }

      if (nextButton) {
        nextButton.disabled = isLast;

        nextButton.setAttribute(
          "aria-disabled",
          isLast ? "true" : "false"
        );
      }
    }

    function updateStatus() {
      if (!status || !flkty) return;

      const current = flkty.selectedIndex + 1;
      const total = flkty.slides.length;

      status.textContent =
        "Product feature " +
        current +
        " of " +
        total;
    }

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        if (prevButton.disabled) return;

        flkty.previous();
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        if (nextButton.disabled) return;

        flkty.next();
      });
    }

    slider.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft") {
        event.preventDefault();

        if (!prevButton.disabled) {
          flkty.previous();
        }

        return;
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();

        if (!nextButton.disabled) {
          flkty.next();
        }

        return;
      }

      if (event.key === "Home") {
        event.preventDefault();
        flkty.select(0);
        return;
      }

      if (event.key === "End") {
        event.preventDefault();
        flkty.select(flkty.slides.length - 1);
        return;
      }
    });

    flkty.on("ready", function () {
      updateButtons();
      updateStatus();
    });

    flkty.on("scroll", function (progress) {
      sliderProgress = Math.max(0, Math.min(1, progress));

      updateButtons();
    });

    flkty.on("select", function () {
      updateButtons();
      updateStatus();
    });

    flkty.on("settle", function () {
      updateButtons();
    });

    updateButtons();
    updateStatus();

    let resizeTimer;

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(function () {
        if (!flkty) return;

        flkty.resize();
        flkty.reposition();

        updateButtons();
        updateStatus();
      }, 150);
    });
  });
});